import { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import Chip from "@mui/material/Chip";
import Skeleton from "@mui/material/Skeleton";
import axiosInstance from "config/axiosInstance";
import Table from "examples/Tables/Table";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import { formatTimePeru } from "utils/datePeru";
import RecipientNameCell from "./RecipientNameCell";
import {
  formatMonto,
  formatOrigenLabel,
  getStatusUi,
} from "utils/whatsappUi";

export default function RecentSendsTable({ refreshKey = 0, limit = 12, embedded = false }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    const load = async () => {
      setLoading(true);
      try {
        const res = await axiosInstance.get("/whatsapp/queue/history", {
          params: { limit },
        });
        if (active && res.data.success) {
          setItems(res.data.items || []);
        }
      } catch {
        if (active) setItems([]);
      } finally {
        if (active) setLoading(false);
      }
    };
    load();
    return () => {
      active = false;
    };
  }, [refreshKey, limit]);

  const rows = items.map((item) => {
    const statusKey = item.displayStatus || item.estado;
    const ui = getStatusUi(statusKey);
    return {
      hora: formatTimePeru(item.hora || item.sent_at || item.created_at),
      destinatario: (
        <RecipientNameCell
          nombre={item.destinatario_nombre}
          telefono={item.telefono_destino}
        />
      ),
      estado: (
        <Chip
          label={`${ui.emoji} ${ui.label}`}
          size="small"
          color={ui.color}
          variant="filled"
          sx={{ fontWeight: 600 }}
        />
      ),
      monto: formatMonto(item.monto),
      origen: formatOrigenLabel(item.destino_origen),
    };
  });

  const content = (
    <VuiBox sx={{ overflowX: "auto" }}>
      {loading ? (
        <VuiBox p={2}>
          {[1, 2, 3, 4].map((i) => (
            <Skeleton key={i} height={36} sx={{ mb: 1, bgcolor: "rgba(255,255,255,0.06)" }} />
          ))}
        </VuiBox>
      ) : (
        <>
          <Table
            brightHeader
            columns={[
              { name: "hora", label: "Hora", align: "left" },
              { name: "destinatario", label: "Destinatario", align: "left" },
              { name: "estado", label: "Estado", align: "center" },
              { name: "monto", label: "Monto", align: "right" },
              { name: "origen", label: "Origen", align: "center" },
            ]}
            rows={rows}
          />
          {rows.length === 0 && (
            <VuiBox py={3} textAlign="center">
              <VuiTypography variant="button" color="text">
                Aún no hay envíos registrados
              </VuiTypography>
            </VuiBox>
          )}
        </>
      )}
    </VuiBox>
  );

  if (embedded) {
    return content;
  }

  return (
    <Card sx={{ p: 0, mt: 2 }}>
      <VuiBox px={2.5} pt={2.5} pb={1}>
        <VuiTypography variant="h6" color="white" fontWeight="bold">
          Envíos recientes
        </VuiTypography>
      </VuiBox>
      {content}
    </Card>
  );
}
